import React from "react";
import { Table, Input, Button, Space, Image, Tag } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

import Quickview from "./Quickview";
class RenderTable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };
  selectproduct = () => {
    this.props.setselectedproduct(true, this.props.List);
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      // {
      //   title: "SL",
      //   key: "index",
      //   render: (value, item, index) => {
      //     return index + 1;
      //   },
      // },
      {
        title: "Head",
        dataIndex: "",
        key: "x",
        render: (details) => {
          return details.Subgroup != null ? details.Subgroup : " ";
        },
      },
      {
        title: "Narration",
        dataIndex: "narration",
        key: "narration",
      },
      // {
      //   title: "Head",
      //   dataIndex: "",
      //   key: "x",
      //   render: (details) => {
      //     return details.Subgroup != null ? details.Subgroup : " ";
      //   },
      // },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
      },
      // {
      //   title: "Debit",
      //   dataIndex: "",
      //   key: "x",
      //   render: (details) => {
      //     if (details.increase) {
      //       return (
      //         <>
      //           {details.print[0].normally_Debit == "Debit"
      //             ? details.amount
      //             : ""}
      //         </>
      //       );
      //     } else {
      //       return (
      //         <>
      //           {details.print[0].normally_Debit != "Debit"
      //             ? details.amount
      //             : ""}
      //         </>
      //       );
      //     }
      //   },
      // },
      // {
      //   title: "Credit",
      //   dataIndex: "",
      //   key: "x",
      //   render: (details) => {
      //     if (details.increase) {
      //       return (
      //         <>
      //           {details.print[0].normally_Debit == "Credit"
      //             ? details.amount
      //             : ""}
      //         </>
      //       );
      //     } else {
      //       return (
      //         <>
      //           {details.print[0].normally_Debit != "Credit"
      //             ? details.amount
      //             : ""}
      //         </>
      //       );
      //     }
      //   },
      // },
    ];
    return <Table rowKey="id" columns={columns} dataSource={this.props.List} />;
  }
}

export default RenderTable;
